export default __webpack_public_path__ + "static/media/Header.49a87d98.png";